import { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from '@mui/material/TableRow';
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { useStyles } from "../../../../assets/muiStyles";


const StyledTableCellHead = styled(TableCell)(() => ({
    fontSize: 14,
    color: "#44485A",
    fontWeight: 700,
    whiteSpace: "nowrap",
    textTransform: "capitalize",
    backgroundColor: "transparent",
    padding: "10px 16px",
    borderBottom: "none",
    fontFamily: 'Sarabun, sans-serif'
}));


const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'isSectionId',
})(({ isSectionId }) => ({
    backgroundColor: isSectionId ? '#e8e8e8' : '#e9eff8',
}));


const TableHeadComponent = ({
    options,
    isRowMenuAvialable,
    selectedRow,
    rows,
    handleSelectAllRows,
    showMandatory,
    showCheckbox,
    isSectionId
}) => {
    const classes = useStyles();
    const [allowEdit, setAllowEdit] = useState(false);
    const [allowDelete, setAllowDelete] = useState(false);

    useEffect(() => {
        setAllowEdit(!!options?.allowEdit);
        setAllowDelete(!!options?.allowDelete);
    }, [options]);

    const isOtherMenu = !!(options?.rowMenu?.length > 0);

    // console.log("TABLE HEADER COMPOENENT : options : ", options)
    // console.log("TABLE HEADER COMPOENENT :selectedRow : ", selectedRow)
    return (
        <TableHead>
            <StyledTableRow isSectionId={isSectionId}>
                <StyledTableCellHead size="small" />

                {options.selectableRows && (
                    <StyledTableCellHead>
                        <Checkbox
                            className={classes.customCheckbox}
                            checked={selectedRow?.length > 0 && selectedRow.length === rows?.length}
                            indeterminate={selectedRow?.length > 0 && selectedRow.length < rows?.length}
                            onChange={handleSelectAllRows}
                            sx={{
                                color: "#fff",
                                borderRadius: "2px",
                                marginLeft : "3px",
                                '&.Mui-checked': {
                                    color: "#fff",
                                    borderColor: "transparent",
                                    border: "none",
                                },
                                '&.MuiCheckbox-indeterminate': {
                                    backgroundColor: "transparent",
                                    borderColor: "transparent",
                                    color: "#fff",
                                },
                                '&:hover': {
                                    backgroundColor: "transparent",
                                    color: "#fff",
                                },
                            }}
                        />
                    </StyledTableCellHead>
                )}

                {options?.rowMenu && options?.rowMenu.length && isOtherMenu ? (
                    <StyledTableCellHead size="small" />
                ) : isRowMenuAvialable ? (
                    <StyledTableCellHead size="small" />
                ) : null}

                {options.actionableRows && (
                    <StyledTableCellHead size="small" />
                )}

                {options?.columnNames &&
                    Object.entries(options.columnNames)?.map(([key, value], i) => {
                        const column = options?.columnTemplate?.find((item) => item.id === key);
                        const isMandatory = showMandatory && column?.mandatory;

                        return (
                            <StyledTableCellHead key={`${key}-${i}`}>
                                {isMandatory && <span style={{ color: "red" }}>*</span>} {value}
                            </StyledTableCellHead>
                        );
                    })}

                {(allowEdit || allowDelete) && (
                    <StyledTableCellHead size="small" />
                )}
            </StyledTableRow>
        </TableHead>
    );
};

export default TableHeadComponent;
